module.exports = __webpack_public_path__ + "static/frontUserNew/img/code-applet.99296e3f.jpg";